import { Injectable } from '@angular/core';
import { ICanieria, IQueryParam, IUpdateCanieria } from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../../auxiliares/helper.service';
import { HttpService } from '../../../auxiliares/http.service';
import { IConfigs } from 'src/app/modulos/offline/configuracion-canal/bluetooth.service';
import { apiBase } from 'src/environments/environment';
const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class CanieriaService {
  constructor(private http: HttpService) {}

  public getConfig(deveui: string, config: IConfigs) {
    return this.http.post(`${api}/comandos/caudal/getConfigs`, {
      deveui,
      config,
    });
  }

  public reset(deveui: string) {
    return this.http.post(`${api}/comandos/caudal/reset`, {
      deveui,
    });
  }

  public setConfig(deveui: string, config: any) {
    return this.http.post(`${api}/comandos/caudal/setConfigs`, {
      deveui,
      config,
    });
  }

  // Canieria
  public getCanieria(id: string): Observable<ICanieria> {
    return this.http.get(`${api}/canierias/${id}`);
  }

  public getCanierias(queryParams?: IQueryParam): Observable<{
    data: ICanieria[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/canierias`, { params });
  }

  public updateCanieria(
    id: string,
    data: IUpdateCanieria,
  ): Observable<ICanieria> {
    return this.http.put(`${api}/canierias/${id}`, data);
  }
  public deleteCanieria(id: string): Observable<ICanieria> {
    return this.http.delete(`${api}/canierias/${id}`);
  }

  public asignarCanieria(
    idCanieria: string,
    idBombeo: string,
    numeroBomba: number,
  ) {
    return this.http.put(`${api}/canierias/asignar`, {
      idCanieria,
      idBombeo,
      numeroBomba,
    });
  }

  public desasignarCanieria(idCanieria: string) {
    return this.http.put(`${api}/canierias/desasignar`, {
      idCanieria,
    });
  }

  public fechaEnXDiasALas00(dias: number): Date {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + dias);
    fecha.setHours(0, 0, 0, 0);
    return fecha;
  }

  public fechaHaceXHorasALas00(horas: number): Date {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    fecha.setMinutes(0, 0, 0);
    return fecha;
  }
}
